var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPractoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.679392
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9353 3.90747C36.3401 3.90747 38.2899 5.85704 38.2899 8.26145C38.2899 10.6665 36.3401 12.6159 33.9353 12.6159C31.5306 12.6159 29.5808 10.6665 29.5808 8.26145C29.5808 5.85704 31.5306 3.90747 33.9353 3.90747ZM4.35552 3.90748C6.76059 3.90748 8.70972 5.85705 8.70972 8.26146C8.70972 10.6665 6.76059 12.6159 4.35552 12.6159C1.95001 12.6159 0 10.6665 0 8.26146C0 5.85705 1.95001 3.90748 4.35552 3.90748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1973 1.822C16.2968 0.779258 17.7631 0 19.8211 0C23.738 0 27.3693 3.3016 27.3693 8.25444C27.3693 13.2066 23.7727 16.5084 19.8211 16.5084C17.9154 16.5084 16.4619 15.7669 15.3619 14.6853L15.3624 21.5783H10.9404V0.473693H15.1973V1.822ZM15.2836 8.26148C15.2836 10.599 16.9993 12.1698 19.1162 12.1698C21.2321 12.1698 22.948 10.6102 22.948 8.26148C22.948 5.91274 21.2321 4.354 19.1162 4.354C16.9993 4.354 15.2836 5.92436 15.2836 8.26148Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractoMobile);
export default __webpack_public_path__ + "static/media/practo-mobile.79f4f9fb.svg";
export { ForwardRef as ReactComponent };